import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import "./search-home-filter.css";
import SearchFilterDate from "./search-filter-date";
import dayjs from "dayjs";
import { serverFetch } from "@src/server";
import { GuestsControl } from "@src/controls";
import { useNavigate  } from 'react-router-dom';
import { useWindowWidth } from "@react-hook/window-size";
import { withoutTime } from "@src/extensions/utils";
import LocalFuncs from "@src/extensions/local-funcs";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/store/hooks";
import { categoryFilterChanged } from "@src/store/actions";
const SearchHomeFilter = () => {
    const d = useAppDispatch();
    const [searchedItems, setSearchedItems] = useState([]);
    const [showSearched, setShowSearched] = useState(false);
    const [selectingItems, setSelectingItems] = useState(false);
    const [openPopover, setOpenPopover] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState();
    const [filter, setFilter] = useState(LocalFuncs.checkFilterPeriod(useSelector((s) => s.reservationRoomFilter))); // Получить скорректированный сохраненный фильтр
    const navigate = useNavigate ();
    const isMobile = useWindowWidth() <= 992;

    // Проверка параметров URL для подстановки в фильтр
    const checkSearchParams = (filter_) => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("setParams")) {
            const newFilter = {...filter_};
            const url = new URL(window.location.href);
            url.searchParams.delete("setParams");
            if (urlParams.get("arrivalDate")){
                newFilter.arrivalDate = dayjs(urlParams.get("arrivalDate"));
                url.searchParams.delete("arrivalDate");
            }
            if (urlParams.get("departureDate")){
                newFilter.departureDate = dayjs(urlParams.get("departureDate"));
                url.searchParams.delete("departureDate");
            }
            if (urlParams.get("adultsQty")){
                newFilter.adultsQty = Number(urlParams.get("adultsQty"));
                url.searchParams.delete("adultsQty");
            }
            if (urlParams.get("childAges")){
                const childAges = urlParams.get("childAges")?.split(",").map(Number);
                newFilter.childAges = childAges || [];
                newFilter.childsQty = childAges?.length ?? 0; 
                url.searchParams.delete("childAges");
            }
            else {
                newFilter.childAges = [];
            }
            const filter2 = LocalFuncs.checkFilterPeriod(newFilter);
            setFilter(filter2);
            d(categoryFilterChanged(filter2));            
            navigate(url, { replace: true });
        }
    }	

    useEffect(() => checkSearchParams(filter), []);

    const onSelectRegion = (value) => {
        switch (value.idx) {
            case 1:
                navigate(`/booking/search/region/${value.url}?place=${value.placeId}`);
                break;
            case 2:
                navigate(`/booking/search/region/${value.url}`);
                break;
            case 3:
                navigate(`/booking/search/category/${value.companyId}`);
                break;
            default:
                break;
        }

        // if (value.idx === 2)
        // setSelectedItem(value);
        // if (value) {
        //     setSearchText(value.regionName);
        //     setFilter({...filter, regionCode: value.url})
        // }
        // setSelectingItems(false);
    }
    const onSearch = (e) => {
        setSelectedItem(null);
        const value = e ? e.target.value : "";
        setSearchText(value);
        serverFetch(`companies/search?text=${value}`)
            .then(data => setSearchedItems(data))
            .catch(ex => console.log('Ошибка получения списка', ex));
    }
    useEffect(onSearch, []);

    const regionItems = searchedItems.filter(i => i.idx === 1 || i.idx === 2);
    const companyItems = searchedItems.filter(i => i.idx === 3);

    const divSearchedItems = [];
    if (regionItems.length > 0) {
        divSearchedItems.push(<div key="1" className="search-home-filter-searched-item-title">МЕСТА и РЕГИОНЫ</div>)
        divSearchedItems.push(...regionItems.map(item => <div key={`${item.placeId}-${item.regionId}-${item.companyId}`} className="search-home-filter-searched-item" 
            onClick={() => onSelectRegion(item)} dangerouslySetInnerHTML={{ __html: item.text }}/>))
    }

    if (companyItems.length > 0) {
        divSearchedItems.push(<div key="3" className="search-home-filter-searched-item-title">ТУРКОМПЛЕКСЫ</div>)
        divSearchedItems.push(...companyItems.map(item => <div key={`${item.placeId}-${item.regionId}-${item.companyId}`} className="search-home-filter-searched-item" 
            onClick={() => onSelectRegion(item)} dangerouslySetInnerHTML={{ __html: item.text }}/>))
    }

    const divSearched = (showSearched || selectingItems) && <div className="search-home-filter-searched-items" 
        onMouseEnter={() => setSelectingItems(true)}
        onMouseLeave={() => setSelectingItems(false)}>
        {divSearchedItems}
    </div>
    const disabledDate = (current) => current && dayjs(current) < withoutTime(dayjs())
    const disabledDateEnd = (current) => current && (dayjs(current) < withoutTime(dayjs()) || current < filter.arrivalDate)
    const onChangeDateBeg = (arrivalDate) => {
        const srok = filter.departureDate.diff(filter.arrivalDate, 'days');
        const departureDate = arrivalDate.add(srok, 'days');
        setFilter({...filter, arrivalDate, departureDate})
    }
    const onChangeDateEnd = (departureDate) => setFilter({...filter, departureDate})

    const onGo = () => {
        d(categoryFilterChanged(filter))
        navigate(`/booking/search/region/${selectedItem?.urlName}`)
    }
    return  <>
        <div className="search-home-filter">
            <div className="search-home-filter-body">
                <div className="search-home-filter-segment search-home-filter-segment-region">
                    <div className="search-home-field">
                        <div className="search-home-field-label">РЕГИОН ИЛИ НАПРАВЛЕНИЕ</div>
                        <div className="search-home-field-control">
                            <img src="/images/search.svg" alt="" />
                            <Input placeholder="Введите название региона" className="search-home-input" 
                                bordered={false}
                                onFocus={() => setShowSearched(true)}
                                onBlur={(e) => setShowSearched(false)}
                                value={searchText}
                                onChange={onSearch}
                            />
                        </div>
                    </div>
                </div>
                {divSearched}
                <div className="search-home-filter-segment search-home-filter-segment-dates">
                    <SearchFilterDate title="ЗАЕЗД" value={filter.arrivalDate} onChange={onChangeDateBeg} disabledDate={disabledDate} format={isMobile ? 'DD.MM.YY' : 'DD.MM.YYYY'}/>
                    <SearchFilterDate title="ВЫЕЗД" value={filter.departureDate} onChange={onChangeDateEnd} disabledDate={disabledDateEnd} format={isMobile ? 'DD.MM.YY' : 'DD.MM.YYYY'}/>
                </div>
                <div className="search-home-filter-segment search-home-filter-segment-guests">
                    <div className="search-home-field">
                        <div className="search-home-field-label">КТО ЕДЕТ</div>
                        <GuestsControl filter={filter} setFilter={setFilter} openPopover={openPopover} handleOpenPopoverChange={setOpenPopover} icon={<img src="/images/people.svg" alt="" />}/>
                    </div>
                </div>
                <div className="search-home-filter-segment search-home-filter-segment-button">
                    <Button className="search-home-button" disabled={!selectedItem} onClick={onGo}>Найти</Button>
                </div>
            </div>
        </div>
    </>
}

export default SearchHomeFilter;